import axios from '../api';

export async function getLeaderboardRank(userId, type = 'lifetime') {
  // Hole die Top 100 für Performance
  const res = await axios.get(`/users/leaderboard/${type}?page=1&pageSize=100`);
  const items = res.data.items || [];
  const idx = items.findIndex(u => String(u.id) === String(userId));
  return idx >= 0 ? idx + 1 : null;
}
